(() => {
  const init = () => {
    const z = document.querySelector('.zoom');
    if (!z || z.dataset.layloZoom) return;
    const track = z.querySelector('.zoom__track');
    if (!track) return;
    z.dataset.layloZoom = '1';

    const s = document.createElement('style');
    s.textContent = `.zoom__item img{width:min(1000px,100%) !important;max-width:none !important;height:auto !important;cursor:zoom-in}
.zoom.is-big .zoom__item img{width:100% !important;cursor:zoom-out}
.zoom__track{transform-origin:0 0}`;
    document.head.appendChild(s);

    let anim;

    // Klik: slå zoom til/fra for alle billeder, blød animation via transform
    track.querySelectorAll('.zoom__item img').forEach(img => img.addEventListener('click', e => {
      e.stopPropagation();
      if (anim) anim.cancel();
      stopGlide();
      const r = img.getBoundingClientRect();
      const fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      z.classList.toggle('is-big');
      let r2 = img.getBoundingClientRect();
      z.scrollTop += (r2.top + fy * r2.height) - e.clientY;
      r2 = img.getBoundingClientRect();
      const sc = r.width / r2.width;
      const T = track.getBoundingClientRect();
      const Nx = r2.left + fx * r2.width, Ny = r2.top + fy * r2.height;
      const dx = e.clientX - T.left - sc * (Nx - T.left);
      const dy = e.clientY - T.top - sc * (Ny - T.top);
      anim = track.animate(
        [{ transform: `translate(${dx}px,${dy}px) scale(${sc})` }, { transform: 'none' }],
        { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    }));

    // Nulstil zoom når visningen lukkes
    const reset = () => { z.classList.remove('is-big'); stopGlide(); };
    const closeBtn = z.querySelector('.zoom__close');
    if (closeBtn) closeBtn.addEventListener('click', reset);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') reset(); });

    // Scroll: ét swipe glider blødt til næste stop
    const stops = () => {
      const vh = z.clientHeight, out = [];
      const base = z.getBoundingClientRect().top - z.scrollTop;
      track.querySelectorAll('.zoom__item').forEach(it => {
        const img = it.querySelector('img');
        if (!img) return;
        const r = img.getBoundingClientRect();
        const imgTop = r.top - base;
        if (r.height < vh * 1.25) { out.push(Math.round(imgTop + (r.height - vh) / 2)); return; }
        const top = Math.round(imgTop);
        const bottom = top + r.height - vh;
        out.push(top);
        for (let y = top + vh * 0.85; y < bottom; y += vh * 0.85) out.push(Math.round(y));
        if (bottom > top) out.push(Math.round(bottom));
      });
      const max = z.scrollHeight - vh;
      return [...new Set(out.map(y => Math.min(Math.max(0, y), max)))].sort((a, b) => a - b);
    };

    let raf = null, lockUntil = 0, lastWheel = 0, armed = true, acc = 0;
    function stopGlide() { if (raf) cancelAnimationFrame(raf); raf = null; }
    function glideTo(target) {
      stopGlide();
      const from = z.scrollTop, d = target - from, dur = 560, t0 = performance.now();
      const ease = t => 1 - Math.pow(1 - t, 3);
      const step = t => {
        const p = Math.min(1, (t - t0) / dur);
        z.scrollTop = from + d * ease(p);
        if (p < 1) raf = requestAnimationFrame(step); else raf = null;
      };
      raf = requestAnimationFrame(step);
      lockUntil = performance.now() + dur;
    }

    z.addEventListener('wheel', e => {
      if (e.ctrlKey) return; // knib-zoom virker normalt
      e.preventDefault();
      const now = performance.now();
      const newGesture = now - lastWheel > 140;
      lastWheel = now;
      if (newGesture) acc = 0;
      // ignorer trackpad-efterløb efter et glid
      if (newGesture || (now > lockUntil + 200 && Math.abs(e.deltaY) >= 40)) armed = true;
      if (!armed || now < lockUntil) return;
      acc += e.deltaY;
      if (Math.abs(acc) < 90) return; // kræver lidt scroll før den flytter sig
      const dir = Math.sign(acc);
      armed = false; acc = 0;
      const cur = z.scrollTop, list = stops(), min = z.clientHeight * 0.3;
      const target = dir > 0
        ? list.find(y => y > cur + min)
        : ([...list].reverse().find(y => y < cur - min) ?? (cur > 4 ? 0 : undefined));
      if (target !== undefined) glideTo(target);
    }, { passive: false });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
